import { types } from "../../types/types"
import AfiliadoTurnosService from '../../services/AfiliadoTurnosService'
import { finishSpinner, startSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import { OBRAS_SOCIALES } from "../../utils/constants";

export const getDiasTurnosDisponibles = (idEspecialidad, idCentroMedico, idProfesional, virtual) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.traerTurnosDiasStart })
    try {
        const result = await AfiliadoTurnosService.getDiasDisponibles(idEspecialidad, idCentroMedico, idProfesional, virtual)
        const body = await result.json()
        if (result.ok) {
            dispatch(finishSpinner());
            dispatch({
                type: types.traerTurnosDiasSuccess,
                payload: body
            })
            if(body.length > 0){
                if(idProfesional !== null && idProfesional !== ""){
                    dispatch(getTurnosDisponibles(idEspecialidad, idCentroMedico, idProfesional, virtual, body[0], null))
                }else{
                    dispatch(getHorasTurnosDisponibles(idEspecialidad, idCentroMedico, virtual, body[0]))
                }
            }
            
        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerTurnosDiasError })
        console.log("Error al traer los dias disponibles para el turno", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

// Este trae las horas cuando no se selecciona profesiona
export const getHorasTurnosDisponibles = (idEspecialidad, idCentroMedico, virtual, fecha) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.traerTurnosHorasStart })
    try {
        const result = await AfiliadoTurnosService.getHorasDisponibles(idEspecialidad, idCentroMedico, virtual, fecha)
        const body = await result.json()
        if (result.ok) {
            dispatch(finishSpinner());
            dispatch({
                type: types.traerTurnosHorasSuccess,
                payload: body
            })
        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerTurnosHorasError })
        console.log("Error al traer las horas disponibles para el turno", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}


export const getTurnosDisponibles = (idEspecialidad, idCentroMedico, idProfesional, virtual, fecha, hora) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.traerTurnosHorariosStart })
    try {
        const result = await AfiliadoTurnosService.getTurnosDisponibles(idEspecialidad, idCentroMedico, idProfesional, virtual, fecha, hora)
        const body = await result.json()
        if (result.ok) {
            dispatch(finishSpinner());
            dispatch({
                type: types.traerTurnosHorariosSuccess,
                payload: body
            })
        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerTurnosHorariosError })
        console.log("Error al traer los horarios disponibles para el turno", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}



export const getPrimerTurnoDisponible = (idEspecialidad, idCentroMedico, idProfesional, virtual) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.traerPrimerTurnoDisponibleStart })
    try {
        const result = await AfiliadoTurnosService.getPrimerTurnoDisponible(idEspecialidad, idCentroMedico, idProfesional, virtual)
        if (result.status === 204){
            dispatch(finishSpinner());
            dispatch({ type: types.traerPrimerTurnoDisponibleError })
        }else{
            const body = await result.json()

            if (result.ok) {
                dispatch(finishSpinner());
                dispatch({
                    type: types.seleccionarTurnoAfiliado,
                    payload: body
                })
            } else {
                throw body.errores
            }
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerPrimerTurnoDisponibleError })
        console.log("Error al traer el primer turno disponible", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const seleccionarTurno = (payload) => ({ type: types.seleccionarTurnoAfiliado, payload: payload});
export const limpiarDatosDeTurnosParametrosAnteriores = () => ({ type: types.limpiarDatosDeTurnosParametrosAnteriores});

export const getTurnosAfiliado = (credenciales) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.traerTurnosAfiliadoStart })
    try {
        const turnosAfiliados=[]
        // eslint-disable-next-line
        for (let index = 0; index < credenciales.length; index++) {
            const result = await AfiliadoTurnosService.getMisTurnos(credenciales[index].idAfiliado,
                credenciales[index].nroDocumento,
                OBRAS_SOCIALES.OSPEDYC)
            const body = await result.json()
            if (result.ok) {
                // eslint-disable-next-line
                body.map(turno=>{//body es un array de turnos
                    turnosAfiliados.push(turno)
                })
            } else {
                throw body.errores
            }
        }

        dispatch({
            type: types.traerTurnosAfiliadoSuccess,
            payload: turnosAfiliados
        })
        dispatch(finishSpinner());

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerTurnosAfiliadoError })
        console.log("Error al traer los turnos del afiliado", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const getHistorialTurnosAfiliado = (credenciales) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.traerHistorialTurnosAfiliadoStart })
    try {
        const turnosAfiliados=[]
        // eslint-disable-next-line
        for (let index = 0; index < credenciales.length; index++) {
            const result = await AfiliadoTurnosService.getMisTurnosConcurridos(credenciales[index].idAfiliado,
                credenciales[index].nroDocumento,
                OBRAS_SOCIALES.OSPEDYC);
            const body = await result.json()
            if (result.ok) {
                // eslint-disable-next-line
                body.map(turno=>{//body es un array de turnos
                    turnosAfiliados.push(turno)
                })
            } else {
                throw body.errores
            }
        }

        dispatch({
            type: types.traerHistorialTurnosAfiliadoSuccess,
            payload: turnosAfiliados
        })
        dispatch(finishSpinner());

    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerHistorialTurnosAfiliadoError })
        console.log("Error al traer los turnos del afiliado", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const getMotivosBaja = () => async (dispatch) => {
    dispatch({ type: types.traerMotivosBajaTurnosStart })
    try {
        const result = await AfiliadoTurnosService.getMotivosBaja()
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.traerMotivosBajaTurnosSuccess,
                payload: body
            })
        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch({ type: types.traerMotivosBajaTurnosError })
        console.log("Error al traer los motivos de baja para el turno", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}